export const onlyFirstName = (name: string) => {
  const fullName = name.split(' ')

  return fullName[0]
}
